import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  ponudaMoguca,
  zapamtiOdbijanje,
  type DogadajPonude,
} from "@/lib/instalacija";

/**
 * The offer to put the app on the home screen — Android's half of §2.9.
 *
 * iOS gets written steps because it has no such thing; Android has an event,
 * and left alone the browser shows its own strip at a moment of its choosing,
 * in its own words, to whoever happens to be looking. Captured, the offer is
 * made after signing in, to a site manager, in a sentence that says why it
 * matters: an app started from the home screen is the one that keeps his
 * unsent hours.
 *
 * Installing is not a precondition on Android — the storage survives either
 * way — so this is an improvement and is written like one. It says no once
 * and stays quiet.
 */
export function PonudaZaInstalaciju() {
  const [dogadaj, setDogadaj] = useState<DogadajPonude | null>(null);

  useEffect(() => {
    if (!ponudaMoguca()) {
      return;
    }

    const uhvati = (nezgrapni: Event) => {
      // Without this Chrome shows its own bar as well, and the manager is
      // asked the same question twice in two different voices.
      nezgrapni.preventDefault();
      setDogadaj(nezgrapni as DogadajPonude);
    };

    window.addEventListener("beforeinstallprompt", uhvati);
    return () => window.removeEventListener("beforeinstallprompt", uhvati);
  }, []);

  if (!dogadaj) {
    return null;
  }

  const odbij = () => {
    zapamtiOdbijanje();
    setDogadaj(null);
  };

  return (
    <section
      role="status"
      className="avm-surface flex flex-wrap items-center gap-3 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-card)] p-4"
    >
      <div className="min-w-0 flex-1">
        <p className="font-medium">Dodajte aplikaciju na početni zaslon</p>
        <p className="text-[var(--color-muted-foreground)]">
          Otvara se kao aplikacija, bez trake preglednika, i unosi bez mreže
          ostaju spremljeni.
        </p>
      </div>

      <div className="flex gap-2">
        <Button
          onClick={() => {
            void dogadaj.prompt();
            // The banner goes as soon as the browser's own dialog is up: the
            // answer is given there, and either way this has done its job.
            // `userChoice` is deliberately not awaited - a manager who
            // declines has declined the browser, not us, and we do not record
            // that as a refusal of the offer.
            setDogadaj(null);
          }}
        >
          Dodaj
        </Button>
        <Button variant="outline" onClick={odbij}>
          Ne sada
        </Button>
      </div>
    </section>
  );
}
